import './App.css';
import WeddingForm from './Wedding-form';

function App() {
  return (
    <>
    <WeddingForm />
    </>
  );
}

export default App;
